import commonSlice from '@/state/common.slice';
import store from '@/state/store';
import { AlertColor } from '@mui/material';

export default (text: string, type: AlertColor = 'error') => {
  store.dispatch(commonSlice.actions.showMessage({ type, text }));
};
